import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import './App.css';

import NavBar from './components/NavBar'
import AboutPage from './components/AboutPage'
import LandingPage from './components/LandingPage'
import MainPage from './components/MainPage'
import ProjectPage from './components/ProjectPage'
import CreatingPage from './components/CreatingPage'

import SoftTissue from './components/creating/SoftTissue'
import CartoonAroony from './components/creating/CartoonAroony'
import DontShootFilms from './components/creating/DontShootFilms'
import Waharoa from './components/creating/Waharoa'
import DuetsWithMyWhanau from './components/creating/DuetsWithMyWhanau'

import PowerRangers from './components/coaching/PowerRangers'
import BlackHands from './components/coaching/BlackHands'
import Mystic from './components/coaching/Mystic'
import TheCalf from './components/coaching/TheCalf'
import Flip from './components/coaching/Flip'
import Foodie from './components/coaching/Foodie'
import BloodAndBone from './components/coaching/BloodAndBone'
import Cleaver from './components/coaching/Cleaver'
import Stranger from './components/coaching/Stranger'
import EverybodyElseIsTaken from './components/coaching/EverybodyElseIsTaken'
import TurtleBankHustler from './components/coaching/TurtleBankHustler'

function App() {
  return (
    <div className="App">
      <Router>
        <NavBar />
        <Switch>
          <Route path="/project">
            <ProjectPage />
          </Route>
          <Route key="creating" path="/creating">
            <CreatingPage />
          </Route>
          <Route key="coaching" path="/coaching">
            <MainPage />
          </Route>
          <Route key="about" path="/about">
            <AboutPage />
          </Route>
          <Route key="softTissue" path="/soft-tissue">
            <SoftTissue />
          </Route>
          <Route key="cartoonAroony" path="/cartoonaroony">
            <CartoonAroony />
          </Route>
          <Route key="DontShootFilms" path="/dont-shoot-films">
            <DontShootFilms />
          </Route>
          <Route key="Waharoa" path="/waharoa">
            <Waharoa />
          </Route>
          <Route key="duetsWithMyWhanau" path="/duets-with-my-whanau">
            <DuetsWithMyWhanau />
          </Route>
          <Route key="PowerRangers" path="/power-rangers">
            <PowerRangers />
          </Route>
          <Route key="BlackHands" path="/black-hands">
            <BlackHands />
          </Route>
          <Route key="Mystic" path="/mystic">
            <Mystic />
          </Route>
          <Route key="TheCalf" path="/the-calf">
            <TheCalf />
          </Route>
          <Route key="Flip" path="/flip">
            <Flip />
          </Route>
          <Route key="Foodie" path="/foodie">
            <Foodie />
          </Route>
          <Route key="BloodAndBone" path="/blood-and-gold">
            <BloodAndBone />
          </Route>
          <Route key="Cleaver" path="/cleaver">
            <Cleaver />
          </Route>
          <Route key="Stranger" path="/stranger">
            <Stranger />
          </Route>
          <Route key="EverybodyElseIsTaken" path="/everybody-else-is-taken">
            <EverybodyElseIsTaken />
          </Route>
          <Route key="TurtleBankHustler" path="/turtle-bank-hustler">
            <TurtleBankHustler />
          </Route>
          <Route path="/">
            <LandingPage />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
